








































































import {
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import GuardarButton from '@/reusable/Modal/GuardarButton.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  Evaluaciones,
  ScriptValidacionRespuesta,
} from '@/interfaces/ContratoProveedor';
import CodeView from '@/reusable/CodeView/CodeView.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { ServicioProxy } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';

import { evaluarScriptRespuesta } from '@/pantallas/ContratoProveedor/Services/evaluarScriptRespuesta';

@Component({
  components: {
    CabeceraModal,
    GuardarButton,
    ModalMantenedor,
    FormFieldsContainer,
    CodeView,
  },
})
export default class ValidarRespuestaModal extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ required: true, default: '' }) script: string;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  axios = new AxiosVue(ServicioProxy.Dispositivo);

  formFields: FormFieldDefMap = {
    actividad1: {
      label: '',
      id: 'actividad1',
      value: '',
    },
    actividad2: {
      label: '',
      id: 'actividad2',
      value: '',
    },
    actividad3: {
      label: '',
      id: 'actividad3',
      value: '',
    },
    respuesta1: {
      label: '',
      id: 'respuesta1',
      value: '',
    },
    resultado1: {
      label: '',
      id: 'resultado1',
      value: '',
    },
    resultado2: {
      label: '',
      id: 'resultado2',
      value: '',
    },
    resultado3: {
      label: '',
      id: 'resultado3',
      value: '',
    },
  };

  handleCerrar() {
    this.$emit('cerrar', this.formFields.respuesta1.value);
  }

  @Watch('script', { deep: true })
  handleScriptChange() {
    if (this.script) {
      this.formFields.respuesta1.value = this.script;
    }
  }

  async habldevalidarRespuesta() {
    let model: any = {
      Script: this.formFields.respuesta1.value,
      Ejemplos: [
        this.formFields.actividad1.value.toString(),
        this.formFields.actividad2.value.toString(),
        this.formFields.actividad3.value.toString(),
      ],
    };
    const res: any = await this.axios.http.post(
      'dispositivo/evaluavalidacion',
      model
    );
    let cont = 1;
    res.data.value.ejemplos.forEach((x: any) => {
      switch (cont) {
        case 1:
          this.formFields.resultado1.value =
            x.mensaje != '' ? x.mensaje : x.valor;
          break;
        case 2:
          this.formFields.resultado2.value =
            x.mensaje != '' ? x.mensaje : x.valor;
          break;
        case 3:
          this.formFields.resultado3.value =
            x.mensaje != '' ? x.mensaje : x.valor;
          break;

        default:
          break;
      }
      cont++;
    });
  }
}
